export const Tabs = {
  Users: "Users",
  Stylists: "Stylists",
  Salons: "Salons",
};

export const DBUserType = {
  [Tabs.Users]: "U",
  [Tabs.Stylists]: "ST",
  [Tabs.Salons]: "SA",
};

export function UserTabs({ selectedTab, setSelectedTab }) {
  return (
    <div className="p-1 rounded-[10px] border border-[#d7d7d7] justify-start items-center gap-px flex">
      {Object.values(Tabs).map((tab) => (
        <button
          onClick={() => setSelectedTab(tab)}
          key={tab}
          className={`px-3.5 py-2 w-20 ${
            selectedTab === tab ? "bg-black text-white" : "text-black"
          } rounded-lg poppins  text-sm font-medium justify-center items-center gap-2.5 flex`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
